<template>
    <div class="scene">
        <div class="text text1">We meet on March 15, 2020.</div>
        <div class="text text2">At Jiangqiao Wanda Plaza.</div>
        <div class="flipdown flipdown__theme-light">
            <div class="rotor-group" v-for="(item, i) in items" :key="`item-${i}`">
                <div class="rotor-group-heading">{{item.title}}</div>
                <div class="rotor" v-for="(part, j) in item.parts" :key="`part-${i}-${j}`">
                    <div :class="item.activity?'rotor-leaf flipped':'rotor-leaf'">
                        <div class="rotor-leaf-rear">{{part}}</div>
                        <div class="rotor-leaf-front">{{part}}</div>
                    </div>
                    <div class="rotor-top">{{part}}</div>
                    <div class="rotor-bottom">{{part}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';


export default {
    data: () => {
        return {
            items: [{
                    title: "Days",
                    parts: [0, 0, 0],
                    activity: false
                },
                {
                    title: "Hours",
                    parts: [0, 0],
                    activity: false
                },
                {
                    title: "Minutes",
                    parts: [0, 0],
                    activity: false
                },
                {
                    title: "Seconds",
                    parts: [0, 0],
                    activity: false
                }
            ],
            currentSecond: 0
        }
    },

    mounted() {
        const startTime = "2020-03-15 16:00:00"
        const startDate = new Date(startTime)
        const date = new Date()
        var diff = date.getTime() - startDate.getTime()
        this.currentSecond = diff / 1000.0
        this.startTimer()
    },

    methods: {

        startTimer() {
            this.updateSecond();
            this.timer = setInterval(() => {
                this.updateSecond();
            }, 1000);
        },

        getParts(num, min) {
            const strNum = "" + num
            const strArr = strNum.split("")
            console.log("strArr", strArr)
            let items = []
            const count = strArr.length
            for (let i = 0; i < min - count; i++) {
                items.push(0)
            }
            for (let i = 0; i < strArr.length; i++) {
                items.push(parseInt(strArr[i]))
            }
            return items
        },

        updateItem(idx, data, min) {
            let item = this.items[idx]
            item.activity = true
            Vue.set(this.items, idx, item)

            setTimeout(() => {
                item.parts = this.getParts(data, min)
                Vue.set(this.items, idx, item)
            }, 250)

            setTimeout(() => {
                item.activity = false
                Vue.set(this.items, idx, item)
            }, 800)
        },

        updateSecond() {
            const timeObj = {
                day: Math.floor(this.currentSecond / (60 * 60 * 24)),
                hours: Math.floor(this.currentSecond / 60 / 60) % 24,
                minutes: Math.floor(this.currentSecond / 60) % 60,
                seconds: Math.floor(this.currentSecond % 60)
            }

            Object.keys(timeObj).forEach((key, idx) => {
                if (!this.timeObj || this.timeObj[key] != timeObj[key]) {
                    this.updateItem(idx, timeObj[key], key == 'day' ? 4 : 2)
                }
            })

            this.timeObj = timeObj
            this.currentSecond++
        },

    },

    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer)
        }
    }
};
</script>

<style scoped>
@import url(./flipdown.css);

.scene {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
}

.text {
    font: bold 200% Consolas, Monaco, monospace;
    font-size: 20px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    border-right: .05em solid;
}

.text1 {
    width: 310px;
    animation: typing 6s steps(15), caret 1s steps(1) infinite;
}

.text2 {
    margin-top: 20px;
    margin-bottom: 20px;
    width: 300px;
    animation: typing 6s steps(15), caret 1s steps(1) infinite;
}

@keyframes typing {
    from {
        width: 0;
    }
}

@keyframes caret {
    50% {
        border-right-color: transparent;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/scene4/Scene4.vue